const initialState = null;
const ads = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_VAP_DATA_SUCCESS':
			return Object.assign({},state,{ ...action.payload });
		case 'GET_VAP_DATA_FAILURE':
			return Object.assign({},state, {  });
		case 'GET_BIKE_POINT_DATA_SUCCESS':
			return {
				...state,
				pointData: action.payload
			};
		case 'GET_BIKE_POINT_DATA_FAILURE':
			return Object.assign({},state, {  });
		case 'RESET_BIKE_POINT_DATA':
			return Object.assign({},state,{ pointData: [] });
		case 'GET_EARN_POINT_SUCCESS':
			return Object.assign({},state,{ earnTexts: [...action.payload.earnText] });
		case 'GET_EARN_POINT_FAILURE':
			return Object.assign({},state, {  });
		case 'GET_VAP_RESPONSE_SUCCESS':
			return Object.assign({},state,{ ...action.payload });
		case 'GET_VAP_RESPONSE_FAILURE':
			return Object.assign({},state, {  });
		case 'GET_OWNER_DETAILS_SUCCESS':
			return Object.assign({},state,{ ...action.payload  });
		case 'GET_OWNER_DETAILS_FAILURE':
			return Object.assign({},state,{  });
		case 'SET_SELLER_DATA':
			return Object.assign({},state,{ ...action.data  });
		case 'SET_VAP_DATA':
			return Object.assign({},state,{ ...action.data, sellerMobile: null, sellerEmail: null });
		case 'GET_DEAL_DETAILS_SUCCESS':
			if (action.payload) {
				return Object.assign({},state,{ dealDetails: { ...action.payload } });
			} else {
				return state;
			}
		default:
			return state;
	}
};

export default ads;


// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/vap.js